import { OrderStatus } from './order-status.entities';

export const ORDER_STATUSES = new Map<string, OrderStatus>([
  ['Successful', 'completed'],
  ['Completed', 'completed'],
  ['Created', 'created'],
  ['In Progress', 'in-progress'],
  ['Cancelled', 'cancelled'],
  ['Rejected', 'rejected'],
]);
